module.exports = __webpack_public_path__ + "assets/ceiba-alt.f56a8b70.svg";